import React, { useState, Fragment } from "react";
import { useStylesApp } from "hooks/useStyles";
import { useSelector } from "react-redux";

//mostrar empresa
import {
  Grid,
  Card,
  Divider,
  CardHeader,
  Typography,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";

//material-ui.com
import { makeStyles } from "@material-ui/core/styles";

//componentes del sistema

//componentes para el boton buscar
import Button from "@material-ui/core/Button";

import { useStylesGlobal } from "configurations/styles/theme";

//Color para la advertencia
import {
  palette,
  styleInput,
  msmSwalError,
  msmSwalExito,
} from "configurations/styles/theme";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import clientBackend from "configurations/axios";
import { getRUCEmpresa } from "redux/actions/userActions";
const useStyles = makeStyles((theme) => ({
  cardContent: {
    width: "94%",
    height: "400px",
    margin: "3%",
  },
  gridLable: {
    // paddingRight: '1%'
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  divBotonBuscar: {
    marginTop: "0.5%",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuSeleccion: {
    zIndex: "3000  ! Important",
    width: "60% !Important",
  },
  infoBusqueda: {
    marginTop: "30px",
    marginBottom: "30px",
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  fragment: {
    padding: "10px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const MassiveRucsQuery = () => {
  const classes = useStyles();
  const tokenUser = useSelector((state) => state.user.tk);
  const classesGlobales = useStylesGlobal();
  const classesApp = useStylesApp();
  const [openLoader, setOpenLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [file, setFile] = useState(null);
  var fileSaver = require("file-saver");

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };
  const uploadExcel = async () => {
    setOpenLoader(true);
    const formData = new FormData();
    formData.append("file", file);
    await clientBackend
      .post("/admin/clientes/verificar/loteRuc", formData, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status === 200) {
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(blob, `Consulta-${Date.now()}.xlsx`);
          // msmSwalExito("Comprobantes enviados para autorizar exitosamente.");
          setOpenLoader(false);
          setFile(null);
        } else {
          msmSwalError("Error al cargar el archivo de consulta.");
          setOpenLoader(false);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          msmSwalError(
            exception.response.data.apierror
              ? exception.response.data.apierror.mensaje
                ? exception.response.data.apierror.mensaje
                : "Error al cargar el archivo de consulta."
              : "Error al cargar el archivo de consulta."
          );
          setOpenLoader(false);
        } else {
          msmSwalError(
            "Existen problemas en la red. Contáctese con el administrador del Sistema."
          );
        }
        setOpenLoader(false);
      });
  };

  return (
    <Fragment className={classes.fragment}>
      <Card className={classes.cardContent}>
        <Grid container xs={12} justify="center" alignItems="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Carga de rucs para consulta masiva "}
            avatar={<QueryStatsOutlinedIcon></QueryStatsOutlinedIcon>}
          />
        </Grid>

        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          align="center"
        >
          <Grid container>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
            <Grid item xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Los campos marcados con (
                <font color={palette.error.main}> *</font>) son obligatorios:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={2} xs={12}>
              <Typography aling="center" color="primary" variant="subtitle2">
                Archivo en formato (.xlsx):
                <font color={palette.error.main}> *</font>
              </Typography>
            </Grid>
            <Grid item lg={2} xs={12}>
              <input
                type="file"
                name="file"
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.cufe ? (
                <p className={classesApp.errorLetters}>{errors.cufe}</p>
              ) : null}
            </Grid>
          </Grid>
          <br></br>
          <Grid>
            <Divider className={classes.divider} />
          </Grid>

          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} lg={2}>
              <Button variant="outlined" color="primary" onClick={uploadExcel}>
                Cargar Archivo
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Backdrop className={classes.backdrop} open={openLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Card>
    </Fragment>
  );
};

export default MassiveRucsQuery;
